
<template>

    <div :class="[ToggleState]">
        a
        <table class="ListTable" ref="ListTable">
            <tr class="Header" >

                <td v-for="column in m_Columns"
                    class="CaptionContainer"
                    :ColumnName="column.ColumnName"
                    @click="OnColumnHeaderClick(column.ColumnName)"
                    :class="[column.HeaderClassName]"
                   
                    style="background-color:aqua"
                    >
                    aa
                    <template v-if="HeaderTextSlot != null">
                        <slot name="HeaderText"
                              :HeaderText="column.HeaderText"></slot>

                    </template>
                    <template v-else>
                        {{column.HeaderText}}
                    </template>

                    <template v-if="SortByColumn != '' && SortByColumn==column.ColumnName">
                        <template v-if="Scending == 'ASC'">
                            ▴
                        </template>
                        <template v-else="Scending == 'ASC'">
                            ▾
                        </template>
                    </template>
                </td>

            </tr>
            <tr v-for="row in m_Rows" class="Row"
                :class="{'Active' : row == SelectedRow}"
                @click="OnRowClick(row)">
                <template v-if="RowSlot != null">
                    <slot name="Row"
                          :row="row"></slot>

                </template>
                <template v-else>

                    <template v-for="column in m_Columns">
                        <td>

                            <slot :name="column.ColumnName"
                                  :Row="row"></slot>
                        </td>
                    </template>
                </template>

            </tr>

            <tr v-if="m_Rows != null && m_Rows.length == 0">
                <td :colspan="m_Columns.length + 1">
                    沒有資料
                </td>
            </tr>
        </table>

        <div v-if="ToggleState=='Collapsed' && m_Rows != null && m_Rows.length>10"
             class="DotLine">
            ...
        </div>
        <div class="ToggleButtonContainer"
             v-if="m_Rows != null && m_Rows.length>10">
            <t-button class="Button Toggle Expand" style="width:100%"
                      @click="()=>{ToggleState='Expanded'}"
                      title="展開"> ▼</t-button>
            <t-button class="Button Toggle Collapse" style="width:100%"
                      @click="()=>{ToggleState='Collapsed'}"
                      title="收起"> ▲ </t-button>
        </div>
 
        <paging :PagingData="m_PagingData"
                v-if="ShowPaging != 'false' && ShowPaging != false"
                v-on:change="OnPagingDataChange" />
         
    </div>



</template>

<script scoped>
    import Utility from '@/Common/Utility';
    import apiService from '@/Common/ApiService';
    import PlugableControlBase from "@/Common/PlugableControlBase";
    import eventBus from '@/Common/EventBus';


    export default {
        name: "ListView2",
        data() {
            return {
                m_Columns: [],
                RowSlot: null,
                HeaderTextSlot:null,
                SortByColumn: "",
                Scending: "ASC",
                ToggleState: "NONE",

                SelectedRow:null,
                m_QueryHandler: null,

                m_Rows: [
                ],

                m_PagingData: {
                    RecordPerPage: 10,
                    TotalCount: 1000,
                    CurrentPageNumber: 1,
                },

            }
        }
        ,

        props: ["Rows", "Columns", "PagingData", "OrderBy", "QueryHandler","ShowPaging","EnableToggle"],

        methods: {

            QueryList() {
                this.m_PagingData.CurrentPageNumber = 1;
                this._QueryList();
            },

            LoadRows(rows) {
                this.m_Rows = rows;

                this.$emit("change", this.m_Rows);
            },

            _QueryList() {

                if (this.m_QueryHandler != null) {
                    
                    Utility.ShowLoadingPicture();
                    this.m_QueryHandler(this.m_PagingData, this.OrderBy).then(
                        function (responseData) {
                            Utility.HideLoadingPicture();

                            this.m_Rows = responseData.Rows;

                            if (responseData.Paging != null) {
                                this.m_PagingData = responseData.Paging;
                            }

                            setTimeout(
                                function () {
                                    if (this.m_Rows.length > 0) {
                                        this.PrepareColumns();
                                    }
                                    else {
                                        this.PrepareColumnsWithNoRows();
                                    }
                                }.bind(this),
                                100
                            );


                            this.$emit("change", this.m_Rows);

                        }.bind(this)
                    );
                }
            },

            OnPagingDataChange(pagingData) {

                this.m_PagingData = pagingData;
                this.$emit("PagingDataChange", this.m_PagingData);
                this._QueryList();
            },

            OnColumnHeaderClick(columnName) {

                if (columnName != null && columnName != "") {

                    this.SortByColumn = columnName;

                    if (this.Scending == "ASC") {
                        this.Scending = "DESC"
                    }
                    else {
                        this.Scending = "ASC"
                    }


                    this.m_PagingData.OrderBy = this.SortByColumn + " " + this.Scending;

                    this.m_PagingData.CurrentPageNumber = 1;    
                    this.OrderBy = this.SortByColumn + " " + this.Scending;
                    this.$emit("OrderByChange", this.OrderBy);

                    this._QueryList();

                }
            },

            OnRowClick(row) {
                this.SelectedRow = row;
                this.$emit("RowClick", row);
            },

            PrepareColumnsWithNoRows() {

                
                this.Rows.push(
                    {
                        ValueSet: {

                        }
                    }
                );
                this.$forceUpdate();

                setTimeout(
                    function () {
                        this.PrepareColumns();
                        this.Rows.length = 0;
                    }.bind(this),
                    10
                );
            },

            PrepareColumns() {
                let listTableElement;
                let i;



                listTableElement = this.$refs.ListTable;

                //this.m_Columns.length = 0;

                if (this.$refs.ListTable.rows.length >= 2) {
                    for (i = 0; i < this.$refs.ListTable.rows[1].cells.length; i++) {
                        let tdElement;
                        let headerText;
                        let columnName;
                        let headerStyle;
                        let headerClassName;

                        tdElement = listTableElement.rows[1].cells[i];
                        headerText = tdElement.getAttribute("HeaderText");
                        columnName = tdElement.getAttribute("ColumnName");
                        headerStyle = tdElement.getAttribute("HeaderStyle");
                        headerClassName = tdElement.getAttribute("HeaderClassName");

                        if (this.m_Columns.length <= i) {
                            this.m_Columns.push({
                                HeaderText: "",
                                ColumnName: ""
                            }
                            );
                        }
                        this.m_Columns[i].HeaderText = headerText;

                        if (columnName != null) {
                            this.m_Columns[i].ColumnName = columnName;
                        }

                        if (headerStyle != null) {
                            this.m_Columns[i].HeaderStyle = headerStyle;
                        }

                        if (headerClassName != null) {
                            this.m_Columns[i].HeaderClassName = headerClassName;
                        }
                    }

                    this.$forceUpdate();
                }

            },




        },

        beforeMount() {
        },

        created: function () {

            this.m_Rows = this.Rows;
           
            this.m_QueryHandler = this.QueryHandler;

            this.RowSlot = null;
             
            if (this.PagingData != null) {
                this.pagingData = this.PagingData;
            }
        },


        mounted: function () {
            let vnodes;
            let i;


            this.m_Rows = this.Rows;

            this.m_Columns = [];



            for (let columnName in this.$scopedSlots) {
                 if (columnName == "Row" || columnName == "row") {
                    this.RowSlot = this.$scopedSlots[columnName];

                    if (this.Rows != null && this.Rows.length == 0) {
                        this.PrepareColumnsWithNoRows();
                    }
                    else {
                        setTimeout(
                            function () {
                                this.PrepareColumns();
                            }.bind(this),
                            10
                        );
                    }
                }
                else if (columnName == "HeaderText") {
                    this.HeaderTextSlot = this.$scopedSlots[columnName];
                }
            }



            this._QueryList();


            if (this.EnableToggle == true || this.EnableToggle == "true") {
                this.ToggleState = "Collapsed";
            }
            else {
                this.ToggleState = "NONE";
            }

        },

        beforeMounted() {

        },

        beforeDestroy() {
            this.Destroyed = true;
            this.KeepConnectionRunning = false;
        },

        components: {
        },


        computed: {

        },

        watch: {

            Rows(newVal) {
                this.m_Rows = newVal;
            },

            PagingData(newVal) {

                if (newVal != null) {
                    this.m_PagingData = newVal;
                    this.$forceUpdate();
                }
            },

            '$route'(to, from) {

                // Put your logic here...
            }

        },

        beforeRouteLeave(to, from, next) {

            next();
        }


    }
</script>

<style>
    .Chat .ButtonList .Button {
        margin-bottom: 5px;
    }

    @media screen and (max-width:660px) {
        .Chat .ButtonList .Button {
            padding-left: 2px;
            padding-right: 2px;
        }
    }
</style>
<style scoped>

    .ListTable tr.Header td:not([ColumnName='']) {
        cursor: pointer;
    }

    .Button.Toggle {
        background-color: white;
        color: #666666;
        font-size: 20px;
        padding-left: 0px;
        padding-right: 0px;
        border:1px solid #e0e0e0;
    }

    .NONE .ToggleButtonContainer {
        display: none;
    }

    .Collapsed .Button.Toggle.Collapse {
        display:none;
    }
    .Collapsed .Button.Toggle.Expand {
        display: block;
    }

    .Expanded .Button.Toggle.Collapse {
        display: block;
    }

    .Expanded .Button.Toggle.Expand {
        display: none;
    }


    .DotLine { 
        font-size: 30px;
        display: block;
        width: 100%;
        text-align: center;
        position:relative;
        top:-20px;
    }


    .NONE .DotLine,
    .Expanded .DotLine {
        display: none;
    }

    .Collapsed .ListTable > tr.Row:nth-child(n+12){
        display: none;
    }

</style>
